import {
    FORM_RESPONSE_LIST_REQUEST,
    FORM_RESPONSE_LIST_SUCCESS,
    FORM_RESPONSE_LIST_FAIL,
    FORM_RESPONSE_LIST_RESET,
    FORM_RESPONSE_DETAILS_REQUEST,
    FORM_RESPONSE_DETAILS_SUCCESS,
    FORM_RESPONSE_DETAILS_FAIL,
    FORM_RESPONSE_CREATE_REQUEST,
    FORM_RESPONSE_CREATE_SUCCESS,
    FORM_RESPONSE_CREATE_FAIL,
    FORM_RESPONSE_CREATE_RESET,
    FORM_RESPONSE_UPDATE_REQUEST,
    FORM_RESPONSE_UPDATE_SUCCESS,
    FORM_RESPONSE_UPDATE_FAIL,
    FORM_RESPONSE_UPDATE_RESET,
    FORM_RESPONSE_DELETE_REQUEST,
    FORM_RESPONSE_DELETE_SUCCESS,
    FORM_RESPONSE_DELETE_FAIL,
    FORM_RESPONSE_DELETE_RESET,
    FORM_RESPONSE_BY_PATIENT_REQUEST,
    FORM_RESPONSE_BY_PATIENT_SUCCESS,
    FORM_RESPONSE_BY_PATIENT_FAIL,
    FORM_RESPONSE_LIST_BYIDS_REQUEST,
    FORM_RESPONSE_LIST_BYIDS_SUCCESS,
    FORM_RESPONSE_LIST_BYIDS_FAIL,
    FORM_RESPONSE_LIST_BYIDS_RESET,
    FORM_RESPONSE_DTO_REQUEST,
    FORM_RESPONSE_DTO_SUCCESS,
    FORM_RESPONSE_DTO_FAIL,
    FORM_RESPONSE_DTO_RESET
} from '../constants/formResponseConstants';

export const formResponseListReducer = (
    state = {
        formResponses: []
    }, action) => {
    switch (action.type) {
        case FORM_RESPONSE_LIST_REQUEST:
            return { loading: true, formResponses: [] };
        case FORM_RESPONSE_LIST_SUCCESS:
            return {
                loading: false,
                formResponses: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
            };
        case FORM_RESPONSE_LIST_FAIL:
            return { loading: false, error: action.payload, formResponses: [] };
        case FORM_RESPONSE_LIST_RESET:
            return { formResponses: [] };
        default:
            return state;
    }
};

export const formResponseDetailsReducer = (
    state = {
        formResponse: {}
    }, action) => {
    switch (action.type) {
        case FORM_RESPONSE_DETAILS_REQUEST:
            return { loading: true, formResponse: {} };
        case FORM_RESPONSE_DETAILS_SUCCESS:
            return { loading: false, formResponse: action.payload };
        case FORM_RESPONSE_DETAILS_FAIL:
            return { loading: false, error: action.payload, formResponse: {} };
        default:
            return state;
    }
};

export const formResponseByPatientReducer = (state = { formResponses: [] }, action) => {
    switch (action.type) {
        case FORM_RESPONSE_BY_PATIENT_REQUEST:
            return { loading: true, formResponses: [] };
        case FORM_RESPONSE_BY_PATIENT_SUCCESS:
            return { loading: false, formResponses: action.payload };
        case FORM_RESPONSE_BY_PATIENT_FAIL:
            return { loading: false, error: action.payload, formResponses: [] };
        default:
            return state;
    }
};

export const formResponseCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case FORM_RESPONSE_CREATE_REQUEST:
            return { loading: true }
        case FORM_RESPONSE_CREATE_SUCCESS:
            return { loading: false, success: true, formResponse: action.payload }
        case FORM_RESPONSE_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case FORM_RESPONSE_CREATE_RESET:
            return {}
        default:
            return state
    }
};

export const formResponseUpdateReducer = (state = {} , action) => {
    switch (action.type) {
        case FORM_RESPONSE_UPDATE_REQUEST:
            return { loading: true }
        case FORM_RESPONSE_UPDATE_SUCCESS:
            return { loading: false, success: true, formResponse: action.payload }
        case FORM_RESPONSE_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case FORM_RESPONSE_UPDATE_RESET:
            return { formResponse: {} }
        default:
            return state
    }
};

export const formResponseDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case FORM_RESPONSE_DELETE_REQUEST:
            return { loading: true }
        case FORM_RESPONSE_DELETE_SUCCESS:
            return { loading: false, success: true }
        case FORM_RESPONSE_DELETE_FAIL:
            return { loading: false, error: action.payload }
        case FORM_RESPONSE_DELETE_RESET:
            return {}
        default:
            return state
    }
};

export const formResponseListByIdsReducer = (
    state = {
        loading: false,
        formResponses: [],
        error: null
    }, action) => {
    switch (action.type) {
        case FORM_RESPONSE_LIST_BYIDS_REQUEST:
            return { loading: true, formResponses: [], error: null };
        case FORM_RESPONSE_LIST_BYIDS_SUCCESS:
            return { loading: false, formResponses: action.payload, error: null };
        case FORM_RESPONSE_LIST_BYIDS_FAIL:
            return { loading: false, error: action.payload, formResponses: [] };
        case FORM_RESPONSE_LIST_BYIDS_RESET:
            return { loading: false, formResponses: [], error: null };
        default:
            return state;
    }
};

export const formResponseDtoReducer = (state = { formResponseDto: {} }, action) => {
    switch (action.type) {
        case FORM_RESPONSE_DTO_REQUEST:
            return { loading: true, formResponseDto: {} };
        case FORM_RESPONSE_DTO_SUCCESS:
            return { loading: false, formResponseDto: action.payload };
        case FORM_RESPONSE_DTO_FAIL:
            return { loading: false, error: action.payload, formResponseDto: {} };
        case FORM_RESPONSE_DTO_RESET:
            return { formResponseDto: {} };
        default:
            return state;
    }
};

